import { InjectionToken } from "@angular/core";

export const WINDOW_ID = new InjectionToken<string>('Window');
